import { computed, inject, Service, signal } from '@angular/core';
import { MgsWebApi } from '../mgs-webapi.service';
import { firstValueFrom } from 'rxjs';
import { IAuditlog, IAuditlogSearch } from '@mng/mgs-lib';
import { IOption, optionsForStrings, withEmptyOption } from '@mng/mng-inputs';
import { MngRouteHelperService } from '@mng/mng-base-ui';

const defaultSearch: IAuditlogSearch = { pageNumber: 0, pageSize: 1000 };

@Service()
export class AuditlogService {
  readonly webApi = inject(MgsWebApi);
  readonly routeHelperService = inject(MngRouteHelperService);

  contexte = signal<string[]>([]);

  auditlogs = signal<IAuditlog[]>([]);

  search = signal<IAuditlogSearch>(defaultSearch);

  contextOptions = computed(() => withEmptyOption(optionsForStrings(this.contexte())));
  typeOptions = signal<IOption[]>(withEmptyOption(optionsForStrings(['ERROR', 'INFO', 'DEBUG'])));

  pageSizeOptions: IOption[] = [
    { name: '100', value: 100 },
    { name: '1000', value: 1000 },
    { name: '10000', value: 10000 }
  ];

  async load() {
    if (this.contexte()?.length === 0) {
      this.contexte.set(await firstValueFrom(this.webApi.auditlogContexte()));
    }

    if (this.auditlogs().length === 0) {
      await this.searchAuditlog();
    }
  }

  updateSearchParams(search: IAuditlogSearch, withRouteUpdate = false) {
    this.search.set(search);
    if (withRouteUpdate) {
      this.routeHelperService.updateRouteWithQueryParams(search);
    }
  }

  async searchAuditlog() {
    const audtilogs = await firstValueFrom(this.webApi.auditlog(this.search()));
    this.auditlogs.set(audtilogs);
  }

  reset() {
    this.search.set(defaultSearch);
    this.auditlogs.set([]);
  }
}
